import type { authClient } from "~/libs/auth.lib";

export type Session = typeof authClient.$Infer.Session;
export type User = (typeof authClient.$Infer.Session)["user"];
